import { CHILD_BEHAVIOR_ISSUES_SCHEMA } from '../../../../../common';

import type { IChildInfo } from '../../../../../common';

let currentChildBehaviorIssuesFormValue: string | null = null;

export function setCurrentChildBehaviorIssuesFormValue(value: string | null) {
  currentChildBehaviorIssuesFormValue = value;
}

export function getCurrentChildBehaviorIssuesFormValue(): string | null {
  return currentChildBehaviorIssuesFormValue;
}

export function hasIntakeChildBehaviorIssuesErrors(
  childInfo: IChildInfo | null | undefined,
  currentBehaviorIssues?: string,
): boolean {
  return !CHILD_BEHAVIOR_ISSUES_SCHEMA.isValidSync({
    child_behavior_issues: currentBehaviorIssues ?? childInfo?.child_behavior_issues ?? '',
  });
}
